var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51436 6.15863C3.19689 6.335 3 6.66962 3 7.03279V11.6715C3 15.3031 4.96892 18.6493 8.14357 20.413L10.5144 21.7301C10.8164 21.8979 11.1836 21.8979 11.4856 21.7301L13.8564 20.413C17.0311 18.6493 19 15.3031 19 11.6715V7.03279C19 6.66962 18.8031 6.335 18.4856 6.15863L11.4856 2.26974C11.1836 2.10195 10.8164 2.10195 10.5144 2.26974L3.51436 6.15863ZM8.96967 12.5303L10.9697 14.5303C11.2626 14.8232 11.7374 14.8232 12.0303 14.5303L16.0303 10.5303C16.3232 10.2374 16.3232 9.76256 16.0303 9.46967C15.7374 9.17678 15.2626 9.17678 14.9697 9.46967L11.5 12.9393L10.0303 11.4697C9.73744 11.1768 9.26256 11.1768 8.96967 11.4697C8.67678 11.7626 8.67678 12.2374 8.96967 12.5303Z",
    fill: "#B8E9C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/Shield.f1e53c05ea7019860f5a82f576cedb99.svg";
export { ForwardRef as ReactComponent };